import { Module } from 'vuex'

import { GetCloseReviewEntryListUseCase } from '@/application/review/getCloseReviewEntryListUseCase'
import { ReviewEntry } from '@/domain/entities/review/reviewEntry'
import { ReviewEntryRepository } from '@/domain/repositories/review/reviewEntryRepository'

interface ReviewEntryState {
  entryList: ReviewEntry[]
  isLoading: boolean
  error: Error | null
}

export const closeReviewEntryModule = (reviewEntryRepository: ReviewEntryRepository): Module<ReviewEntryState, any> => {
  const getCloseReviewEntryListUseCase = new GetCloseReviewEntryListUseCase(reviewEntryRepository)

  return {
    namespaced: true,
    state: {
      entryList: [],
      isLoading: false,
      error: null
    },
    mutations: {
      setEntryList(state, entryList: ReviewEntry[]) {
        state.entryList = entryList
      },
      setLoading(state, isLoading: boolean) {
        state.isLoading = isLoading
      },
      setError(state, error: Error | null) {
        state.error = error
      }
    },
    actions: {
      async fetchReviewEntryList({ commit }, { userId, problemId }: { userId: string; problemId: string }) {
        commit('setLoading', true)
        commit('setError', null)
        try {
          const entryList = await getCloseReviewEntryListUseCase.getByUserIdAndProblemIdCloseEntries(userId, problemId)
          commit('setEntryList', entryList)
        } catch (e) {
          commit('setError', e)
          commit('setEntryList', [])
        } finally {
          commit('setLoading', false)
        }
      }
    },
    getters: {
      entryList: state => state.entryList,
      isLoading: state => state.isLoading,
      error: state => state.error
    }
  }
}
